import React from "react";
import { Dialog, DialogContent, DialogActions } from "@mui/material";
import { useHistory } from "react-router-dom";
import { Stack, Button, Form, Typography } from "@curves/ui-base";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import { CLUB_HOME_ROUTER } from "@icoach/router/routerPath";

const AuthPrivateRoute = props => {
	const history = useHistory();

	const handleOnclose = () => {
		history.replace(CLUB_HOME_ROUTER.ARRIVE);
	};

	return (
		<React.Fragment>
			<Dialog
				open={true}
				onSubmit={handleOnclose}
				PaperProps={{
					className: "wx-90rem",
					component: Form,
				}}
			>
				<GradientColorHeader onClose={handleOnclose}>權限不足</GradientColorHeader>
				<DialogContent className="py-4 px-5">
					<Stack direction="column" spacing="3">
						<Typography color={'error'} variant={'h2'}>目前無此功能權限</Typography>
					</Stack>
				</DialogContent>
				<DialogActions className="px-5">
					<Button variant="contained" type="submit">
						回到首頁
					</Button>
				</DialogActions>
			</Dialog>
		</React.Fragment>
	);
};

export default AuthPrivateRoute;
